import { render } from "./AdminSellers.vue?vue&type=template&id=60698757"
import script from "./AdminSellers.vue?vue&type=script&lang=js"
export * from "./AdminSellers.vue?vue&type=script&lang=js"

import "./AdminSellers.vue?vue&type=style&index=0&id=60698757&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__